import React from "react";

import RolesLayout from "../components/RolesComponent";
import SEO from "../components/seo";

function Roles() {

  return (
    <RolesLayout
    title="Join the team"
    brief={
      [
        "While 2020 has been an unforgettable journey, 2021 looks to have a lot of surprises in store as well.  As the alumni club continues to grow, we are looking for folks who can build a community, strengthen their personal network, and acquire new skills. <br/><br/> If you are looking for an opportunity to become a better version of yourself in the next 3-4 months, look no further. Join the highly motivated and energetic team at the club and kickstart 2021 on a strong note! <br/><br/> If you have any questions, feel free to write to <b><a href='mailto:connect@bmscealumni.club'>connect@bmscealumni.club</a></b>"
      ]
    }
    roles={
      [    
        {
            "name":"UI/UX designer",
            "description":[ "Work closely with the website team and improve the UI/UX of our website",
                            "Constantly update the site with our latest activities and ensure the site is mobile-friendly",
                            "Support the marketing team with creatives and snippets whenever needed."]
        },
        {
            "name":"Events and Podcast",
            "description": [ "Ideate and execute 3-4 events a month, ranging from tech talks to reunions to networking sessions.", 
                             "Reach out to suitable alums and onboard them as speakers. Identify event content and create an outreach campaign with the help of the marketing team.",
                             "Ensure the event reaches our target audience and drive registrations actively."]
        },
        {
            "name":"Video-editor",
            "description": [ "Generate video content from events and meetups for our social media.", 
                             "Coordinate with the marketing and events team to identify the content we need for our handles."]
        },
        {
            "name":"Operations",
            "description": [ "Build and scale our club activities in a systematic method. Monitor our outreach campaigns, identify areas of improvement, and expand the club’s membership base.", 
                             "Handle our communications with alumni and students over email and website queries."]
        },
        {
            "name":"Digital Marketing and Brand Management",
            "description": [ "Create content and distribute it through our channels. Engage with our existing members and build marketing campaigns to grow the community.", 
                             "Manage email communications and social media handles, generate traction and scale our reach.", 
                             "Build a brand from ground up, scale and expand."]
        }
      ]
    }
  
  >
  
    <SEO
      title="Roles:BMSCE Alumni Club"
      keywords={[`bmsce`, `alumni`, `club`, `getscrewed`]}
    />

  </RolesLayout>
  );
}

export default Roles;
